import React, {useState, useEffect, useRef, useMemo} from 'react'
import {useOpenModal} from "#utils/openModal";
import {useMemoizedFn} from 'ahooks'
import './index.less'
import HistoryList, {ItemRender} from "./HistoryList";
import HistoryListStructured from "./HistoryListStructured";

export {renderPrice, renderFileList} from './HistoryList'

export default function useHistoryModal(params = {
    isStructured: false,
    detail: {},
                                        }) {
  const {isStructured, detail} = params
  const [histroyProps, sethistroyProps] = useState({
    title: '',
    list: [],
    renderList: [],
    quoteTableProps: {},
  })
  const {open, destroy} = useOpenModal({
    title: histroyProps.title,
    width: 900,
    children: isStructured ?
        <HistoryListStructured
            detail={detail}
            list={histroyProps.list}
            isInner={true}
        />
        :<HistoryList
          list={histroyProps.list}
          renderList={histroyProps.renderList}
          quoteTableProps={histroyProps.quoteTableProps}
        />,
    closable: true,
    destroyOnClose: true,
    cancelButton: false,
    onOk: () => {
      return true
    },
    afterClose: () => {
      opening.current = false
    },
    okText: '关闭',
  })

  const opening = useRef(false)

  const openHistory = useMemoizedFn(({
    title = '',
    list = [],
     renderList = [],
     quoteTableProps = {},
                                   }: {
    title: string,
    list: any[],
    renderList: ItemRender[],
    quoteTableProps?: any,
  }) => {
    if (opening.current) return
    opening.current = true
    sethistroyProps({
      title,
      list,
      renderList,
      quoteTableProps,
    })
    open()
    opening.current = false
  })

  return {
    openHistory,
    destroy,
  }
}
